import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppStore } from '@aaa/emember/store-types';
import { getQueryMembershipOfferLevel } from '@aaa/emember/store-price-offers';
import { getMembershipLevels } from '../../../store/price-offers/helpers/membership-levels';
import { Pages, toCommands } from '../../../constants/pages';

export const setDefaultMembershipLevel: CanActivateChildFn = (
  childRoute: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store.select(getQueryMembershipOfferLevel).pipe(
    map((queryLevel) => {
      if (!queryLevel) {
        const basicLevel = getMembershipLevels()[0];
        const queryParams = { ...childRoute.queryParams, membershiplevel: basicLevel.level, rv: basicLevel.rv };

        router.navigate(toCommands(Pages.join), { queryParams });

        return false;
      }

      return true;
    }),
  );
};
export default setDefaultMembershipLevel;
